var _ = require('underscore'),
    $ = require('jquery'),
    RaphaelView = require('raphaelItemView');

/* Note tied to and communication with parent which is the shape -- acts like the other subShapes -- could mediate better */

var Helper = function() {
    this.nodes = [];
    this.firstNode = null;
    this.lastNode = null;
    this.currentPathString = '';
    this.polyTempPath = null;
};

module.exports = Helper;

_.extend(Helper.prototype, {
    createFirstNode: function(canvasView, pos) {
        this.firstNode = new FirstDrawNode({
            parent: canvasView,
            position: {x: pos.x, y:  pos.y}
        });
        this.currentPathString  = 'M' + pos.x + ' ' + pos.y;   //now create the path
        this.lastNode = this.firstNode;
        this.nodes.push(this.firstNode);
    },
    createAdditionalNode: function(canvasView, pos) {
        var x = pos.x,
            y = pos.y;
        this.lastNode = new PolyDrawNode({
            parent: canvasView,
            position: {x: x, y: y}
        });
        this.nodes.push(this.lastNode);
        this.currentPathString += ' L' + x + ' ' + y;
    },
    createPolyTempPath: function(paper, pos) {
        if (this.polyTempPath) this.polyTempPath.destroy();
        var lastNodePosition = this.lastNode.position;
        // draw temporary path to from the mouse pointer thing to the mouse position
        this.polyTempPath = new PolyTempPath({
            paper: paper,
            x: pos.x,
            y:  pos.y,
            xLastNode: lastNodePosition.x,
            yLastNode: lastNodePosition.y
        });

    },
    getFinalPath: function() {
        if (this.polyTempPath) this.polyTempPath.destroy();
        this.currentPathString += ' Z'; //end with z
        return this.currentPathString;
    },
    destroy: function() {
        _.invoke(this.nodes.concat([this.firstNode, this.polyTempPath, this.lastNode]), 'destroy');
        this.nodes = [];
        this.firstNode = null; //clear up some references
        this.lastNode = null;
        this.polyTempPath = null;
        this.currentPathString = null;
    }
});


var PolyTempPath = RaphaelView.extend({
    svgAttrs: {
        stroke: '#7F7F7F',
        'stroke-width': 1,
        'fill-opacity': 0.25
    },
    initialize: function(options) {
        var x = options.x,
            y = options.y;
        this.parent = options.parent;
        this.path = 'M' + options.xLastNode + ' '  + options.yLastNode + 'L' + (x > 0 ? x : 0) + ' ' + (y > 0 ? y : 0);
        this.render(options);
    },
    render: function(options) {
        var el = options.paper.path(this.path).attr(this.svgAttrs).toBack();  // put behind nodes
        this.setElement(el);
        return this;
    }
});

var PolyDrawNode = RaphaelView.extend({
    radius: 5,
    svgAttrs: {
        fill: '#00FFFF',
        stroke: '#0000FF',
        'stroke-width': 2
    },
    initialize: function(options) {
        this.parent = options.parent;
        var p = this.position = options.position,  //STORED -- ACCESSED IN DRAWING
            el = this.parent.paper.circle(p.x, p.y, this.radius).attr(this.svgAttrs);
        this.setElement(el);
        this.parent.trigger('node.created');
    }
});

var FirstDrawNode = PolyDrawNode.extend({
    svgAttrs: {
        fill: '#3BC938',
        stroke: '#158527',
        'stroke-width': 2
    },
    events: {
        'mouseover': 'mouseover',
        'mouseout' : 'mouseout',
        'mousedown': 'mousedown'
    },
    initialize: function() {
        PolyDrawNode.prototype.initialize.apply(this, arguments);
        this.listenToOnce(this.parent, 'node.created', this.moveForward);
    },
    mouseover: function(e) {
        this.el.attr('cursor', 'move');
    },
    mouseout: function(e) {
        this.el.attr('cursor', 'crosshair');  //that which exists when drawing
    },
    mousedown: function(e) {
        e = $.event.fix(e);
        e.stopImmediatePropagation();
        this.parent.trigger('firstnode.clicked', e); //must pass the event
    },
    moveForward: function() {
        this.el.toFront();
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/polygonDrawHelper.js
 ** module id = 363
 ** module chunks = 0
 **/